/*
  Project: Vivafloors
  Author: Thomas
  Bite me
 */

let nr = 0, oldNr = 0;

// How many samples 'Mijn stalen' holds. Mirrors VIVAFLOORS_MAX_FAVORITES in
// inc/functions/selection.php and the copy in templates/components/modal.php.
// How many of those one order holds is a separate limit, on the checkout.
const MAX_FAVORITES = 20;

// this must be a global function, because we just Ajax Rocket Filter to reinit when filtering with Ajax.
window.initFavoriteModal = () => {

  const openModalButton = document.querySelectorAll('.js-favorite-modal');
  const modalBox = document.querySelector('.js-form-modal');

  if (openModalButton && modalBox) {

    const modalBoxTitle = modalBox.querySelector('.js-form-modal__title');
    const modalBoxName = modalBox.querySelector('.js-form-modal__name');
    const modalBoxImage = modalBox.querySelector('.js-form-modal__image');
    const modalBoxGaLabel = modalBox.querySelectorAll('[ga-event-label]');
    const modalBoxAdded = modalBox.querySelector('.js-form-modal__added');
    const modalBoxLimit = modalBox.querySelector('.js-form-modal__limit');
    const modalBoxBundle = modalBox.querySelector('.js-form-modal__bundle');

    // The popup either confirms the addition or explains the maximum. The
    // bundle state belongs to modules/bundles.js and is never shown here.
    const showModalState = function (limitReached) {
      if (modalBoxAdded) modalBoxAdded.hidden = limitReached;
      if (modalBoxLimit) modalBoxLimit.hidden = !limitReached;
      if (modalBoxBundle) modalBoxBundle.hidden = true;
    };

    const openModal = function () {
      modalBox.classList.add('active');
      document.querySelector('body').classList.add('no-scroll');
    };

    const bindCloseButtons = function () {
      const closeButtons = modalBox.querySelectorAll('.js-close-modal');
      if (!closeButtons) return;

      [].forEach.call(closeButtons, close => {
        close.addEventListener('click', function () {
          modalBox.classList.remove('active');
          modalBox.classList.remove('loaded');
          document.querySelector('body').classList.remove('no-scroll');
        });
      });
    };

    const simulateClick = function (elem) {
      const evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      // eslint-disable-next-line
      const canceled = !elem.dispatchEvent(evt);
    };

    for (let i = 0; i < openModalButton.length; i++) {

      openModalButton[i].addEventListener('click', function (e) {
        e.preventDefault();

        // eslint-disable-next-line
        const hiddenFavoriteButton = e.currentTarget.parentNode.querySelector(
          '.simplefavorite-button');
        const currentProduct = e.currentTarget.getAttribute('data-title');
        const currentProductName = e.currentTarget.getAttribute(
          'data-productnaam');
        const currentProductThumb = e.currentTarget.getAttribute(
          'data-thumbnail');

        // The card shows the product name (ACF 'productnaam') as heading with
        // the post title underneath. Without a product name the title moves up.
        if (modalBoxName) {
          modalBoxName.innerHTML = currentProductName || currentProduct;
          modalBoxTitle.innerHTML = currentProductName ? currentProduct : '';
        } else {
          modalBoxTitle.innerHTML = currentProduct;
        }
        modalBoxImage.setAttribute('src', currentProductThumb);
        modalBoxImage.setAttribute('alt', currentProduct);

        // Change GA label for Google Analytics
        for (let i = 0; i < modalBoxGaLabel.length; i++) {
          modalBoxGaLabel[i].setAttribute('ga-event-label', currentProduct);
        }

        // A fourth sample is refused; the popup says so instead of adding it.
        if (!hiddenFavoriteButton.classList.contains('active') && nr >= MAX_FAVORITES) {
          showModalState(true);
          openModal();
          modalBox.classList.add('loaded');
          bindCloseButtons();
          return;
        }

        showModalState(false);

        // If hidden favorite button is active then do not add to favorites again and show popup fast
        if (hiddenFavoriteButton.classList.contains('active')) {
          if (e.currentTarget.classList.contains('btn-heart')) {
            modalBox.classList.add('active');
            modalBox.classList.add('loaded');
          } else {
            simulateClick(hiddenFavoriteButton);
          }
        } else {
          modalBox.classList.add('active');
          document.querySelector('body').classList.add('no-scroll');
          simulateClick(hiddenFavoriteButton);
        }

        // Init all closing options
        bindCloseButtons();

      });
    }
  }

  /* eslint-disable */

  // Count the total number of favorited products
  function favoritedProducts(favorites) {
    let site_index = jQuery('body').data('siteid');
    let siteFavorite = favorites.find(
      favorite => favorite.site_id == site_index);

    // Only products are in posts — filter out null/removed entries
    if (siteFavorite && 'posts' in siteFavorite && siteFavorite.posts) {
      return Object.keys(siteFavorite.posts).filter(
        key => siteFavorite.posts[key] !== null).length;
    } else {
      return 0;
    }
  }

  // If the favorites plugin fires an update for single, when a favorite is added or deleted then this in jQuery :(
  jQuery(document).
    on('favorites-updated-single',
      function (event, favorites, post_id, site_id) {

        if (openModalButton && modalBox) {
          if (modalBox.classList.contains('active')) {
            modalBox.classList.add('loaded');
          }
        }

        if (typeof ga === 'function') {

          setTimeout(function () {

            let utilities = new Favorites.Utilities;

            let current = utilities.siteIndex(
              jQuery('body').data('siteid')['posts']);

            if (current) {

              if (oldNr < Object.keys(current).length) {

                let currentTitle = current[post_id]['title'];
                let currentTitleSplit = current[post_id]['title'].split(' ');

                gtag('event', 'add_to_favorites', {
                  'event_category': 'favorite',
                  'event_label': 'add',
                  'items': [
                    {
                      'item_id': currentTitleSplit[1],
                      'item_name': currentTitle,
                      'quantity': 1,
                      'price': 1
                    }
                  ]
                });

              }
            }
            oldNr = nr;

          }, 1000);

        }

        // Reload page 'Mijn stalen' on change
        if (jQuery('body').hasClass('page-id-29')) {
          location.reload();
        } else {
          // Module scope on purpose: the click handler reads this to decide
          // whether a fourth sample may be added.
          nr = favoritedProducts(favorites);
          if (nr !== 0) {
            if (!jQuery('header .c-favorite-icon .c-favorite-icon__nr').length) {
              jQuery('header .c-favorite-icon').
                prepend('<span class="c-favorite-icon__nr"></span>');
            }
            jQuery('header .c-favorite-icon').
              addClass('c-favorite-icon__favorited');
            jQuery('header .c-favorite-icon .c-favorite-icon__nr').html(nr);
          } else {
            jQuery('header .c-favorite-icon .c-favorite-icon__nr').remove();
            jQuery('header .c-favorite-icon').
              removeClass('c-favorite-icon__favorited');
          }
        }

      });

  // If the favorites plugin fires an update for single, when a favorite is added or deleted then this in jQuery :(
  jQuery(document).
    on('favorites-user-favorites-loaded', function (event, favorites) {

      nr = favoritedProducts(favorites);
      oldNr = nr;

      if (nr !== 0) {
        if (!jQuery('header .c-favorite-icon .c-favorite-icon__nr').length) {
          jQuery('header .c-favorite-icon').
            prepend('<span class="c-favorite-icon__nr"></span>');
        }
        jQuery('header .c-favorite-icon').
          addClass('c-favorite-icon__favorited');
        jQuery('header .c-favorite-icon .c-favorite-icon__nr').html(nr);
      }

    });

};
  
document.addEventListener('DOMContentLoaded', () => {
  window.initFavoriteModal();
});



// WEBPACK FOOTER //
// ./src/scripts/modules/favoriteModal.js